import { Button, Modal, Progress, Stack } from "rsuite";

interface ProgressModalProps {
  open: boolean;
  progress: number;
  progressMsg?: string;
  onCancel: () => void;
}

export default function ProgressModal({
  open,
  progress,
  progressMsg = "Processando…",
  onCancel,
}: ProgressModalProps) {
  return (
    <Modal open={open} onClose={onCancel} backdrop="static" keyboard={false}>
      {/* <Modal.Header>
        <Modal.Title>Importando…</Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <Stack direction="column" spacing={12}>
          <div>{progressMsg}</div>
          <Progress.Line percent={progress} strokeWidth={8} showInfo />
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button appearance="subtle" onClick={onCancel}>
          Cancelar
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
}
